module.exports = __webpack_public_path__ + "assets/8982c9a7c6c761e0070e62d4c1d8fa9d.mp3";